import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';
import FormBirthdate from '../form/birthdate';
import ReCaptcha from '../recaptcha';
import { MediaQuery as MQ } from '../../media-query';

class Component extends BaseComponent {
    constructor() {
        super();
        this.setState({
            accordionOpen: false,
            dailyhoroscope: false,
            weekly_love: false,
            privacy_policy: false,
            recaptcha: { response: null },
        });
    }

    handleChange = (e, name) => {
        name = name || e.target.name;

        this.setState({
            [name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
        });
    }

    handleRecaptchaResponse = (response) => {
        this.setState({
            recaptcha: {
                response: response,
            },
        });
    }

    render({ user }) {
        return (
            <signup-forums>
                <p>
                    Please create a Tarot.com account! Your unique username will allow you to post and reply to topics
                    in the forums and personalize your forums profile page. Plus, a membership comes with many other
                    great perks!
                    <a href='#' onClick={this.toggleAccordion}>&nbsp;Learn More</a>
                </p>
                {this.renderAside()}
                <form onSubmit={this.submit} onKeyUp={this.keyup}>
                    <fieldset class='name-field'>
                        <label class={this.getErrorClass(user.nameError)}>
                            Your Name
                            <input
                              data-action='Type-Name'
                              data-category='Forums'
                              data-label='Signup'
                              data-ga-event
                              name='user_name'
                              onChange={this.handleChange}
                              type='text'
                            />
                        </label>
                        <div class='error'>{ user.nameError }</div>
                    </fieldset>
                    <fieldset class='email-field'>
                        <label class={this.getErrorClass(user.emailError)}>
                            Your Email
                            <input
                              data-action='Type-Email'
                              data-category='Forums'
                              data-label='Login'
                              data-ga-event
                              name='email'
                              onChange={this.handleChange}
                              type='email'
                            />
                        </label>
                        <div class='error'>{ user.emailError }</div>
                    </fieldset>
                    <fieldset class='forum-name-field'>
                        <label class={this.getErrorClass(user.forumNameError)}>
                            Your Forums Username
                            <input
                              data-action='Type-Forum-Name'
                              data-category='Forums'
                              data-label='Signup'
                              data-ga-event
                              name='forum_name'
                              onChange={this.handleChange}
                              type='text'
                            />
                        </label>
                        <div class='error'>{ user.forumNameError }</div>
                    </fieldset>
                    <fieldset class='birthdate-field'>
                        <label class={this.getErrorClass(user.birthDateError)}>
                            Your Birth Date
                            <FormBirthdate
                              data-action='Type-BirthDate'
                              data-category='Forums'
                              data-label='Signup'
                              data-ga-event
                              max={moment(moment().subtract(13, 'year')).format('YYYY-MM-DD')}
                              min='1900-01-01'
                              name='birth_date'
                              onChange={this.handleChange}
                              type='date'
                            />
                        </label>
                        <div class='error'>{ user.birthDateError }</div>
                    </fieldset>
                    <fieldset class='password-field'>
                        <label class={this.getErrorClass(user.passwordError)}>
                            Password
                            <input
                              data-action='Type-Password'
                              data-category='Forums'
                              data-label='Login'
                              data-ga-event
                              name='password'
                              onChange={this.handleChange}
                              type='password'
                            />
                        </label>
                        <div class='error'>{ user.passwordError }</div>
                    </fieldset>
                    <div class='row'>
                        <div class='small-12 medium-6 columns'>
                            <fieldset class='checkbox'>
                                <label>
                                    <input
                                      data-action='Select-Subscribe-DHE'
                                      data-category='Forums'
                                      data-label='Signup'
                                      data-ga-event
                                      name='dailyhoroscope'
                                      onChange={(e) => this.handleChange(e, 'dailyhoroscope')}
                                      type='checkbox'
                                      value='1'
                                      checked={this.state.dailyhoroscope}
                                    />
                                    Get my FREE daily horoscope emails
                                </label>
                                <label class={MQ.isMobile() ? 'checkbox' : ''}>
                                    <input
                                      data-action='Select-Subscribe-WRS'
                                      data-category='Forums'
                                      data-label='Signup'
                                      data-ga-event
                                      name='weekly_love'
                                      onChange={(e) => this.handleChange(e, 'weekly_love')}
                                      type='checkbox'
                                      value='1'
                                      checked={this.state.weekly_love}
                                    />
                                    {this.renderWRS()}
                                </label>
                                {this.renderPPC()}
                            </fieldset>
                        </div>
                        <div class='small-12 medium-6 columns'>
                            <ReCaptcha
                              onChange={this.handleRecaptchaResponse}
                              onExpired={this.handleRecaptchaResponse}
                            />
                            <div class='error'>{ user.captchaError }</div>
                        </div>
                    </div>
                    <br />
                    <button class='button'>Submit</button>
                    {this.renderError()}
                    {this.renderToS()}
                </form>
            </signup-forums>
        );
    }

    renderWRS = () => {
        if (MQ.isMobile()) {
            return (
                <span>Get my FREE weekly horoscope emails</span>
            );
        }

        return 'Get my FREE weekly horoscope emails';
    }

    renderPPC = () => {
        if (!this.props.ppc) {
            return (
                <label class={`checkbox ${this.props.user.privacyPolicyError ? 'error' : ''}`}>
                    <input
                      data-action='Select-Privacy-Policy-Terms-of-Use'
                      data-category='Forums'
                      data-label='Signup'
                      data-ga-event
                      name='privacy_policy'
                      onChange={(e) => this.handleChange(e, 'privacy_policy')}
                      type='checkbox'
                      value='1'
                      checked={this.state.privacy_policy}
                    />
                    <span>
                        &nbsp;I agree to Tarot.com's updated <a href='/privacy-policy' target='_blank'>Privacy Policy
                        </a> and <a href='/terms-of-use' target='_blank'>Terms of Use</a>.
                    </span>
                    <div class='error'>{ this.props.user.privacyPolicyError }</div>
                </label>
            );
        }

        return null;
    }

    renderToS = () => {
        if (this.props.ppc) {
            return (
                <p class='tos-warning'>
                    By continuing, you accept our
                    <a
                      class='text-link-undecorated'
                      data-action='goto_privacy_policy'
                      data-category='Forums'
                      data-label='Signup'
                      data-ga-event
                      href='/privacy-policy'
                      target='_blank'
                    >
                        Privacy Policy
                    </a>
                    &nbsp;and&nbsp;
                    <a
                      class='text-link-undecorated'
                      data-action='goto_terms_of_use'
                      data-category='Forums'
                      data-label='Signup'
                      data-ga-event
                      href='/terms-of-use'
                      target='_blank'
                    >
                        Terms of Use
                    </a>
                    .
                </p>
            );
        }

        return null;
    }

    hasErrors = (inputs) => {
        this.props.userUpdate({
            birthDateError: null,
            generalError: null,
            emailError: null,
            forumNameError: null,
            passwordError: null,
            nameError: null,
            captchaError: null,
            privacyPolicyError: null,
        });

        let errs = 0;

        if (inputs.email.trim().length < 5) {
            this.props.userUpdate({ emailError: 'Please enter your email.' });
            errs++;
        }

        if (! inputs.birth_date) {
            this.props.userUpdate({ birthDateError: 'Please check your birth date.' });
            errs++;
        }

        if (! inputs.user_name.trim().length) {
            this.props.userUpdate({ nameError: 'Please enter your name.' });
            errs++;
        }

        if (! inputs.forum_name.trim().length) {
            this.props.userUpdate({ forumNameError: 'Please enter your forum name.' });
            errs++;
        }

        if (inputs.password.length < 4) {
            this.props.userUpdate({ passwordError: 'Please enter a password longer than 3 characters.' });
            errs++;
        }

        if (!this.props.ppc && !this.state.privacy_policy) {
            this.props.userUpdate({ privacyPolicyError: 'Please accept before continuing.' });
            errs++;
        }

        if (errs) {
            this.props.userUpdate({ generalError: 'Please fill out required fields.' });
        }

        return errs;
    }

    /* eslint-disable complexity */
    submit = (e) => {
        e.preventDefault();

        const inputs = {
            birth_date: this.state.birth_date,
            email: this.state.email || '',
            forum_name: this.state.forum_name || '',
            password: this.state.password || '',
            user_name: this.state.user_name || '',
        };

        let errors = this.hasErrors(inputs);
        let subscribe_lists = ['ipe'];

        if (this.state.dailyhoroscope) {
            subscribe_lists.push('dailyhoroscope');
        }

        if (this.state.weekly_love) {
            subscribe_lists.push('weekly_love');
        }

        if (this.state.recaptcha.response) {
            this.props.checkRecaptcha({ response: this.state.recaptcha.response });
        } else {
            if (! this.props.recaptcha || ! this.props.recaptcha.success) {
                errors = true;
                this.props.userUpdate({ captchaError: 'Captcha validation failed. Please try again.' });
            } else {
                errors = true;
                this.props.userUpdate({ captchaError: 'Please click the "I\'m not a robot box"' });
            }
        }

        if (!errors) {
            let params = {
                account_type_id: 1,
                birth_date: inputs.birth_date,
                cur_fname: inputs.user_name,
                display_name: inputs.user_name,
                first_name: inputs.user_name,
                forum_name: inputs.forum_name,
                email: inputs.email,
                name: inputs.user_name,
                password: inputs.password,
                password_verify: inputs.password,
                privacy_policy: true,
                signup_bonus: true,
                signup_gateway: 'forums-signup',
                signup_pfero: true,
                signup_url: window.location.href,
                subscribe_lists: subscribe_lists,
                timezone: (new Date().getTimezoneOffset() / 60) * -1,
                user_name: inputs.user_name,
            };

            if (this.state.dailyhoroscope) {
                params.subscribe_lists.push('dailyhoroscope');
            }

            if (this.state.weekly_love) {
                params.subscribe_lists.push('weekly_love');
            }

            this.props.userSignupApi(params);
        }

        return false;
    }
    /* eslint-enable complexity */

    keyup = (e) => {
        if (e.keyCode == 27) {
            this.props.routeTo('');
        }
    }

    getErrorClass = (error) => {
        return error ? 'error' : null;
    }

    renderError = () => {
        const error = this.props.user.generalError ? this.props.user.generalError : null;

        if (error) {
            return (
                <div class='error error-center'>{ error }</div>
            );
        }

        return null;
    }

    renderAside = () => {
        if (this.state.accordionOpen) {
            return (
                <aside class='details'>
                    <button onClick={this.toggleAccordion}>✕</button>
                    <h3>Why Should I Join?</h3>
                    <summary>
                        <p>
                            At Tarot.com we translate ancient wisdom for the modern world. Through our unique and
                            personalized content, we want to help guide our users toward understanding what humans
                            knew thousands of years ago … that the answers are within you!
                        </p>
                        <p>
                            By becoming a Tarot.com member, you'll join a community of more than six million members
                            who want to learn and grow as individuals and ultimately, make the world a better place.
                        </p>
                    </summary>
                    <h3>You'll also get:</h3>
                    <ul>
                        <li>20 FREE Karma Coins® tokens</li>
                        <li>A FREE Tarot reading on your birthday</li>
                        <li>Personalized daily Tarot, Astrology & Numerology advice and tips</li>
                        <li>Special discounts on in-depth Tarot readings</li>
                    </ul>
                </aside>
            );
        }

        return null;
    }

    toggleAccordion = (e) => {
        e.preventDefault();
        this.setState({ accordionOpen: !this.state.accordionOpen });
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    recaptcha: state.recaptcha,
    ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: route => dispatch({ type: 'route:to', payload: route }),
    userUpdate: payload => dispatch({ type: 'user:update', payload: payload }),
    userSignupApi: payload => dispatch({ type: 'user:signup-api', payload: payload }),
    checkRecaptcha: payload => dispatch({ type: 'recaptcha:check', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/user/signup-forums.js